import { useEffect, useState } from 'react';
import {
  articleContextEvents,
  ArticleContextValue,
} from './articleContextEvents';

export function useArticleContext(): ArticleContextValue {
  const [context, setContext] = useState<ArticleContextValue>(
    () => articleContextEvents.current,
  );

  useEffect(() => {
    const unsubscribe = articleContextEvents.contextChanged.sub(setContext);

    return () => unsubscribe();
  }, []);

  return context;
}
